"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative overflow-hidden bg-background">
      <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2">
        {}
        <div className="relative flex items-center justify-center bg-background px-8 py-16 lg:px-16 lg:py-24">
          <div className="max-w-xl space-y-6">
            <h2 className="font-display text-4xl font-bold leading-tight text-foreground lg:text-5xl">
              Our Story
            </h2>
            <div className="space-y-4 text-base leading-relaxed text-muted-foreground lg:text-lg">
              <p>
                Specialty Coffee Canada was born from a passion for exceptional coffee and a desire to connect enthusiasts with the nation's finest roasters. We believe that great coffee tells a story—from the bean's origin to the roaster's craft.
              </p>
              <p>
                Our journey began with a simple question: Where can Canadians find the best specialty coffee online? Through meticulous research and community feedback, we curated this collection of outstanding roasters, each verified through Google and Yotpo reviews.
              </p>
              <p>
                Gold Star Coffee leads our list not by chance, but by earning the highest ratings from coffee lovers across the country. Every roaster featured here has been carefully selected for their commitment to quality, transparency, and the art of coffee roasting.
              </p>
              <p>
                We invite you to explore, taste, and discover the rich diversity of Canadian specialty coffee culture—one cup at a time.
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="relative bg-dark-background flex items-center justify-center px-8 py-16 lg:px-16 lg:py-24">
          <div ref={imageRef} className={`group relative transition-all duration-[var(--duration-slow)] ease-out ${imageVisible ? "translate-x-0 opacity-100" : "translate-x-16 opacity-0"}`}>
            <div className="relative overflow-hidden rounded-lg shadow-strong transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:rotate-2 group-hover:shadow-[0_12px_48px_rgb(0_0_0_/_0.24)]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/coffee_culture_artisan_brewing.png" alt="Artisan coffee brewing process" className="h-auto w-full max-w-md object-cover transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)]" />
              {}
              <div className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:opacity-100">
                <div className="h-full w-full bg-gradient-to-br from-transparent via-transparent to-black/40" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}